// extracted by mini-css-extract-plugin
export default {"modalButton":"ChaptersButton-module-modalButton","modalButtonCard":"ChaptersButton-module-modalButtonCard"};